import { useEffect, useState } from "react";
import { countdown } from "../lib/format";

/** Ticks every second; calls `onDone` once when the target passes. */
export function Countdown({ to, onDone }: { to: string | Date; onDone?: () => void }) {
  const [now, setNow] = useState(() => Date.now());
  const target = new Date(to).getTime();

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (now >= target && onDone) onDone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [now >= target]);

  return <span className="tabular-nums">{countdown(target, now)}</span>;
}
